import { action, makeAutoObservable } from 'mobx';
import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { LocalStorageState } from 'src/AppState/LocalStorageState/LocalStorageState';
import { observer } from 'src/utils/mobx-react';
import { Popup } from '../../domains/layouts/shared/popup/Popup';
import {
    AnniversaryButton,
    ButtonTitle,
    ConfettiCanvas,
    Description,
    DetailsWrapper,
    HappyAniversary,
    ImageWrapper,
    ModalWrapper,
    Wrapper,
} from './AnniversaryModal.style';
import Anniversary from './image/anniversary.png';

class TradingPageState {
    constructor(public readonly localStorageState: LocalStorageState) {
        makeAutoObservable(this);
    }

    @action public closeModal = (): void => {
        this.localStorageState.anniversaryInfo.setValue(true);
    };
}

export const AnniversaryModal = observer('AnniversaryModal', () => {
    const { localStorageState } = useAppStateContext();
    const [state] = React.useState(() => new TradingPageState(localStorageState));
    return (
        <ModalWrapper>
            <ConfettiCanvas
                numberOfPieces={700}
                colors={['#DD262D', '#FDC500', '#072D4F', '#3C76CA']}
            />
            <Popup
                width={392}
                isTransparent={true}
                handleHidePopup={state.closeModal}
            >
                <Wrapper>
                    <ImageWrapper imgSrc={Anniversary} />
                    <DetailsWrapper>
                        <HappyAniversary>Happy Anniversary!</HappyAniversary>

                        <Description>Four years ago today StarSports.Bet was launched</Description>
                        <AnniversaryButton onClick={state.closeModal}>
                            <ButtonTitle>Thank you Star</ButtonTitle>
                        </AnniversaryButton>
                    </DetailsWrapper>
                </Wrapper>
            </Popup>
        </ModalWrapper>
    );
});
